import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { initialMvMMarchLocksState, type MvMMarchLocksState } from './state'

export const mvmMarchLocksSlice = createSlice({
  name: 'mvmMarchLocks',
  initialState: initialMvMMarchLocksState as MvMMarchLocksState,
  reducers: {
    lockMvMarchCharactersForAttack: (
      state,
      action: PayloadAction<{ attackId: string; characterIds: string[] }>,
    ) => {
      const aid = String(action.payload?.attackId || '').trim()
      if (!aid) return
      const ids = (action.payload.characterIds || []).map((id) => String(id).trim()).filter(Boolean)
      if (ids.length === 0) return
      state.lockedCharacterIdsByAttackId[aid] = ids
    },
    unlockMvMarchCharactersForAttack: (state, action: PayloadAction<string>) => {
      const aid = String(action.payload || '').trim()
      if (!aid) return
      delete state.lockedCharacterIdsByAttackId[aid]
    },
    clearMvMarchCharacterLocks: () => initialMvMMarchLocksState,
  },
})

export const {
  lockMvMarchCharactersForAttack,
  unlockMvMarchCharactersForAttack,
  clearMvMarchCharacterLocks,
} = mvmMarchLocksSlice.actions

export default mvmMarchLocksSlice.reducer
